import { TYPE_NUMBER } from './input-types';

export const id = 'taxPaid';
export const apiKey = 'TaxPaid';
export const type = TYPE_NUMBER;

export const taxPaid = {
  id,
  apiKey,
  type,
};
